import React from "react";
import { Card, Image } from "semantic-ui-react";
import { Svg } from "../../../../assets";
import { HoloBadge, HoloBorder } from "@/components/Holo";
import "./styles.scss";

export interface AssetPreview {
  assetId: string;
  thumbnail?: string;
  href?: string;
  holo?: boolean;
  /** Shown over a holo thumbnail ("Dynamic" for coaches, "Personalized" for players). */
  badgeLabel?: string;
}

interface OwnProps {
  asset: AssetPreview;
  onClick?: (asset: AssetPreview, e: React.MouseEvent) => void;
}

type Props = OwnProps;

export const AssetPreviewCard: React.FC<Props> = ({ asset, onClick }) => {
  const image = (
    <Image
      as="a"
      src={asset.thumbnail || Svg.PromptPlaceholder}
      className={`previewImage ${asset.thumbnail ? "" : "placeholder"}`}
    />
  );
  return (
    <Card
      className={"assetPreviewCard"}
      link
      onClick={e => {
        onClick && onClick(asset, e);
      }}
      href={asset.href}
    >
      {asset.holo ? (
        <HoloBorder active={false} thickness={1} radius="lg" className="h-full overflow-hidden">
          <div className="relative h-full">
            {image}
            {asset.badgeLabel && (
              <HoloBadge label={asset.badgeLabel} size="sm" className="absolute top-1 left-1 z-10" />
            )}
          </div>
        </HoloBorder>
      ) : (
        image
      )}
    </Card>
  );
};
